import * as React from "react";
import { ResponsivePie, Pie } from "@nivo/pie";
import { Typography } from "@material-ui/core";
import Tooltip from "./PieChartTooltip";

const theme = {
  legends: {
    text: {
      fill: "#fff",
    },
  },
};

const PieChart = (props: any) => {
  const total = props.chartData.reduce((acc: any, next: any) => ({value: acc.value + next.value}),{value: 0}).value;
  const modifiedData = props.chartData.map((item: any) => ({...item, label: `${item.label} - ${((item.value/total)*100).toFixed(1)}%` }));
 
  return (
  <div style={{width:"90%",float:"left"}}>
    <div style={{ marginTop: "40px", marginLeft:"15%" }}>
      <Typography variant="h4" align="left">{props.title}</Typography>
   </div>
    <div style={{height: 280,}}>
      <ResponsivePie
        data={modifiedData}
        theme={theme}
        isInteractive={true}
        margin={{ top: 50, right: 80, bottom: 50, left: -150 }}
        innerRadius={0.9}
        colors={props.colors}
        borderWidth={1}
        enableRadialLabels={false}
        radialLabel={function (e) {
          return e.id + " (" + e.value + ")";
        }}
        radialLabelsSkipAngle={10}
        radialLabelsTextColor="#333333"
        radialLabelsLinkColor={{ from: "color" }}
        enableSliceLabels={false}
        tooltip={Tooltip}
        
        legends={[
          {
            anchor: "right",
            direction: "column",
            justify: false,
            translateX: -60,
            translateY: 1,
            itemsSpacing: 11,
            itemWidth: 102,
            itemHeight: 12,
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 10,
            symbolShape: "circle",
            itemTextColor: "#fff",
          },
        ]}
      />
    </div>
    </div>
  );
}

export default PieChart;
